import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { Grid, Link, Theme, createStyles, makeStyles } from "@material-ui/core";
import { supportEmail } from "../../services/constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    linkText: {
      textDecoration: "none !important",
      color: "primary",
    },
    buttonContainer: {
      justifyContent: "end",
      paddingBottom: "15px",
    },
  })
);

export const LoginDialog = (props: IProps) => {
  const { toggle, onClose, onRetry } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={toggle}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("login_error")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("login_error_body")}{" "}
            <Link
              className={classes.linkText}
              color="primary"
              href={`mailto: ${supportEmail}`}
            >
              {supportEmail}
            </Link>
            {"."}
          </DialogContentText>
        </DialogContent>
        <Grid container className={classes.buttonContainer}>
          <Grid item xs={2}>
            <Button
              onClick={() => {
                onClose();
              }}
            >
              {t("sign_out")}
            </Button>
          </Grid>
          <Grid item xs={2}>
            <Button
              onClick={() => {
                onRetry();
              }}
            >
              {t("retry")}
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export interface IProps {
  toggle: boolean;
  onClose: () => void;
  onRetry: () => void;
}
